export enum BloodDrawConfirmationType {
    SevenDaysBefore = 1,
    TwoDaysBefore = 2,
    Completed = 3,
    NotCompleted = 4
}
